function outlineId(data){
	return {
		type: "outlineId",
		data: data
	}
}

export {outlineId};